export const clearStore = "METRIC_CLEAR_STORE";


export const listLoadStart = 'METRIC_LIST_LOAD_START';
export const listLoadSuccess = 'METRIC_LIST_LOAD_SUCCESS';
export const listLoadFail = 'METRIC_LIST_LOAD_FAIL';

export const itemDeleteStart = 'METRIC_DELETE_START';
export const itemDeleteSuccess = 'METRIC_DELETE_SUCCESS';
export const itemDeleteFail = 'METRIC_DELETE_FAIL';